/*
 * @Author: Claude (Refactored v2)
 * @Date: 2025-12-31
 * @Description: 视频上传组件（Upload 组件的快捷方式）
 */
import { FC } from 'react';

import { GridMediaPreviewItem } from '../common/components/GridMediaPreviewItem';
import { UploadPlaceholder } from '../common/components/UploadPlaceholder';
import { defaultConfig } from '../config';
import { Upload } from '../core/Upload';
import { ACCEPT_FILE_TYPES } from './constants';
import { VideoUploadProps } from './types';

/**
 * 视频上传组件
 * 支持视频文件的上传、预览和删除
 * 本质上是 Upload 组件的预配置版本（previewType="video-grid"）
 */
const VideoUpload: FC<VideoUploadProps> = (props) => {
  const {
    children,
    tips,
    selectable = false,
    accept = ACCEPT_FILE_TYPES,
    ...restProps
  } = props;

  return (
    <Upload
      {...restProps}
      previewType="video-grid"
      config={defaultConfig}
      selectable={selectable}
      accept={accept}
      uploadPlaceholder={<UploadPlaceholder tips={tips} />}
      renderPreview={{
        grid: (file, onDelete, onSelect) => (
          <GridMediaPreviewItem
            key={file.uid}
            file={file}
            mediaType="video"
            selectable={selectable}
            onDelete={onDelete}
            onSelect={onSelect}
          />
        ),
      }}
    >
      {children}
    </Upload>
  );
};

export default VideoUpload;
